module.exports = __webpack_public_path__ + "static/media/conversica_ai.b8101eb2.png";